import { captureException, withScope } from '@sentry/nextjs';
import axios from 'axios';
import { stringify } from 'qs';

import { NETWORK_ERROR, SERVICE_UNAVAILABLE } from './types';

const client = axios.create({
  baseURL:
    process.env.NEXT_PUBLIC_FEATURE_REVERSE_PROXY_API === 'true'
      ? process.env.NEXT_PUBLIC_FINDY_CODE_URL_BASE
      : process.env.NEXT_PUBLIC_EXCALIBUR_API_URL_BASE,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  paramsSerializer: {
    serialize: (p) => stringify(p, { encode: false, arrayFormat: 'brackets' }),
  },
  withCredentials: true,
  xsrfCookieName: 'CSRF-Token',
  xsrfHeaderName: 'X-CSRF-Token',
  timeout: 20000, // 20 seconds
});

client.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const status = error.status || error.response?.status;
    if (status === SERVICE_UNAVAILABLE) {
      window.location.replace('/maintenance');
      return;
    }
    if (error.message === NETWORK_ERROR) {
      withScope((scope) => {
        scope.setTag('source', '@findy-code/yuffie/axios');
        captureException(error);
      });
    }
    return Promise.reject(error);
  }
);

export default client;
